<template>
  <div
    class="row pt-1"
    v-if="isSsoAdmin"
  >
    <div class="col-lg-12">
      <div class="tile-categorie-frame">
        <div class="tile-categorie">
          <div class="header">
            <span>{{ $t('global.administration') }}</span>
          </div>
          <div class="body">
            <div class="row">
              <div :class="kachelCol">
                <div
                  class="tile-frame h-1"
                  :class="kachelStyle"
                >
                  <router-link :to="{ name: 'sso-tenant-liste' }">
                    <div class="tile bg-steel-blue inverted">
                      <div class="icon-container fa-container">
                        <font-awesome-icon
                          icon="fa-duotone fa-key-skeleton"
                          transform="shrink-4"
                        />
                      </div>
                      <div class="title">
                        <span>{{ $t('global.ssoTenants') }}</span>
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StartseiteAdmin',
  components: {},
  mixins: [],
  props: {
    angemeldeterMitarbeiter: { type: Object },
    kachelStyle: { type: String },
    kachelCol: { type: String },
    kachelKleinStyle: { type: String },
    kachelKleinCol: { type: String },
  },
  data() {
    return {
      isAdmin: false,
      isSsoAdmin: false,
    }
  },
  created() {},
  mounted() {
    if (this.gruppen.find((gruppe) => gruppe.id == this.$CONST('GRUPPEN').ADMIN)) {
      this.isAdmin = true
    }
    if (this.gruppen.find((gruppe) => gruppe.id == this.$CONST('GRUPPEN').SSOADMIN)) {
      this.isSsoAdmin = true
    }
  },
  computed: {},
  methods: {},
}
</script>